import Vue from 'vue'

/**
 * @author José Luis R. <jose.ruiz@jbge.com.mx>
 *
 * Reject photos from an affected
 *
 * @param  payload File and id
 * @return {Array} File's info
 */

const rejectSecurityPhotos = payload =>
  Vue.$http.post('workplan/security-photo/reject/', payload)
    .then()
    .catch((err) => {
      throw err
    })

export default rejectSecurityPhotos


// WEBPACK FOOTER //
// ./src/services/workPlan/rejectSecurityPhotos.js